import React, { useState } from 'react';
import Swal from 'sweetalert2'; // Add this import
import './ProductFormModal.css';

function ProductFormModal({ onSubmit, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    annualPrice: '',
    description: '',
    features: [''],
  });

  const handleChange = (e) => {
    
    const { id, value } = e.target;
    console.log(id, value, e.target);
    setFormData({ ...formData, [id]: value });
  };

  const handleFeatureChange = (index, value) => {
    const newFeatures = [...formData.features];
    newFeatures[index] = value;
    setFormData({ ...formData, features: newFeatures });
  };

  const handleAddFeature = () => {
    setFormData({ ...formData, features: [...formData.features, ''] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    const filteredFeatures = formData.features.filter(f => f.trim() !== '');
    
    if (!formData.name.trim() || !formData.price || !formData.description.trim() || filteredFeatures.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Required Fields',
        text: 'Please fill up all the fields',
        width: "300px",
        confirmButtonColor: '#28a745',
        customClass: {
          popup: 'ai-swal-popup',
          title: 'ai-swal-title',
          content: 'ai-swal-content',
          confirmButton: 'ai-swal-confirm-button'
        }
      });
      return;
    }

    try {
      console.log('Submitting form data:', formData);
      const dataToSubmit = {
        ...formData,
        price: parseFloat(formData.price),
        annualPrice: formData.annualPrice ? parseFloat(formData.annualPrice) : null,
        features: filteredFeatures
      };
      
      // Call the onSubmit function
      await onSubmit(dataToSubmit);
      
      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Product created successfully',
        width: "300px",
        confirmButtonColor: '#28a745',
        customClass: {
          popup: 'ai-swal-popup',
          title: 'ai-swal-title',
          content: 'ai-swal-content',
          confirmButton: 'ai-swal-confirm-button'
        }
      });
      
      // Close the modal after successful submission
      onClose();
      
    } catch (error) {
      console.error('Error creating product:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to create product. Please try again.',
        width: "300px",
        confirmButtonColor: '#28a745',
        customClass: {
          popup: 'ai-swal-popup',
          title: 'ai-swal-title',
          content: 'ai-swal-content',
          confirmButton: 'ai-swal-confirm-button'
        }
      });
    }
  };

  return (
    <div className="modal-overlay">
      <div className="product-modal-content">
        <header className="modal-header">
          <h2>Add New Product</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </header>
        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Product Name</label>
            <input 
              type="text" 
              id="name" 
              value={formData.name} 
              onChange={handleChange} 
              required 
            />
          </div>

          <div className="pricing-section">
            <div className="form-group">
              <label htmlFor="price">Monthly Price <span className="required">*</span></label>
              <div className="input-with-currency">
                <span className="currency-symbol">$</span>
                <input 
                  type="number" 
                  id="price" 
                  className="currency-input"
                  step="0.01" 
                  value={formData.price} 
                  onChange={handleChange} 
                  placeholder="0.00"
                  required 
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="annualPrice">Annual Price</label>
              <div className="input-with-currency">
                <span className="currency-symbol">$</span>
                <input 
                  type="number" 
                  id="annualPrice" 
                  className="currency-input"
                  step="0.01" 
                  value={formData.annualPrice} 
                  onChange={handleChange} 
                  placeholder="0.00"
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea 
              id="description" 
              value={formData.description} 
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Features</label>
            <div className="features-container">
              {formData.features.map((feature, index) => (
                <input
                  key={index}
                  type="text"
                  className="feature-input"
                  placeholder="e.g., Unlimited access"
                  value={feature}
                  onChange={(e) => handleFeatureChange(index, e.target.value)}
                />
              ))}
            </div>
            <button type="button" className="add-feature-btn" onClick={handleAddFeature}>
              + Add Another Feature
            </button>
          </div>

          <div className="form-actions">
            <button type="submit" className="save-btn">Save Product</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProductFormModal;